import React, { Component } from "react"
import { Container, Row, Col } from "reactstrap"

import LeadsListHeader from "./LeadsListHeader"
import LeadsList from "./LeadsList"
import ListingTabs from "../Material/ListingTabs"
import ReportsPanel from "../Reports/ReportsPanel"
import withApolloClient from "../withApolloClient"
import { buildPresets } from "../Filters/presetFilters"
import { ROUTES } from "../Layout/routes"
import { usePathTab } from "../Functions/usePathTab"

export const TABS = {
    applicationView: [{ id: "applications", name: "New Applications", iconClassName: "fa fa-user-o" }],
    leadView: [
        { id: "open", name: "Open", iconClassName: "fa fa-user-o" },
        { id: "review", name: "Need Review", iconClassName: "fa fa-wpforms" },
        { id: "didnttakecar", name: "Didn't Take a Car", iconClassName: "fa fa-low-vision" },
        { id: "dnr", name: "DNR", iconClassName: "fa fa-ban" },
        { id: "all", name: "All Leads", iconClassName: "fa fa-handshake-o" },
        { id: "reports", name: "Activity Log", iconClassName: "fa fa-history", floatRight: true, iconOnly: true },
    ]
}
const LEAD_TAB_PRESET_FILTERS = {
    "applications": [
        { fieldName: "status", filterType: "equal", filterValues: ["Onboarding"], editable: false, visible: false },
        { fieldName: "is_archived", filterType: "equal", filterValues: "false", editable: false, visible: false },
    ],
    "open": [
        { fieldName: "status", filterType: "in", filterValues: ["Open", "Contacted"], editable: false, visible: false },
        { fieldName: "is_archived", filterType: "equal", filterValues: "false", editable: false, visible: false },
    ],
    "review": [
        { fieldName: "status", filterType: "equal", filterValues: ["Need Review"], editable: false, visible: false },
        { fieldName: "is_archived", filterType: "equal", filterValues: "false", editable: false, visible: false },
    ],
    "didnttakecar": [
        { fieldName: "status", filterType: "equal", filterValues: ["Canceled"], editable: false, visible: false },
    ],
    "dnr": [
        { fieldName: "is_blocked", filterType: "equal", filterValues: "true", editable: false, visible: false },
        { fieldName: "is_archived", filterType: "equal", filterValues: "false", editable: false, visible: false },
    ],
}

export const getPresetsForTab = (tabId) => buildPresets(LEAD_TAB_PRESET_FILTERS[tabId] || [])

const tableHeaders = [
    { id: "date_added", name: "Date Added", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true }, view: ["applicationView", "leadView"] },
    { id: "id", name: "Lead Info", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: false, canReorder: false }, view: ["applicationView", "leadView"] },
    { id: "status", name: "Status", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true }, view: ["leadView"] },
    { id: "missing_docs", name: "Required Application Docs", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true }, view: ["applicationView", "leadView"] },
    { id: "notes", name: "Notes", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true }, view: ["applicationView", "leadView"] },
    { id: "branch", name: "Applied Branch", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true }, view: ["applicationView", "leadView"] },
    { id: "tags", name: "Driver Tags", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true }, view: ["applicationView", "leadView"] },
    { id: "assigned_to", name: "Assigned To", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true }, view: ["applicationView", "leadView"] },
]

const getDefaultColumnConfig = (viewType) => (
    tableHeaders
        .filter((column) => column.view.includes(viewType))
        .map((column, index) => ({
            ...column,
            order: index,
        }))
)
class LeadsListContainer extends Component {
    constructor(props) {
        super(props)
        const presets = getPresetsForTab(props.activeTabId)
        this.state = {
            tabs: this.props.viewType === "applicationView" ? TABS["applicationView"] : TABS["leadView"],
            filterValues: {
                orderBy: ["-customer__in_office", "-date_added"],
            },
            refetchLeads: false,
            selectedLeads: [],
            columnConfig: getDefaultColumnConfig(props.viewType),
            presets,
            defaultPresets: presets,
        }
    }

    setColumnConfig = (columnConfig) => {
        this.setState({ columnConfig })
    }

    setPresets = (presets) => this.setState({ presets, selectedLeads: [] })

    updateOrder = (string) => {
        let order = [...this.state.filterValues.orderBy]
        if (!order.includes(string) && !order.includes("-" + string)) {
            order = [order.find(item => item.includes("-customer__in_office")), string]
        } else {
            let index = order.indexOf(string)
            if (order.indexOf(string) > -1) {
                order[index] = "-" + string
            } else {
                index = order.indexOf("-" + string)
                index > -1 && (order[index] = string)
            }
        }
        this.setState({ filterValues: { ...this.state.filterValues, orderBy: order } })
    }

    applyTab = (tabId) => {
        const { searchTerm, ...filterValues } = this.state.filterValues
        const presets = getPresetsForTab(tabId)
        this.setState({ filterValues, selectedLeads: [], presets, defaultPresets: presets })
    }

    componentDidUpdate(prevProps) {
        // Leads and Applications share this component; React keeps the instance when the
        // route switches between them, so reset to the new view first.
        if (prevProps.viewType !== this.props.viewType) {
            this.setState({
                tabs: this.props.viewType === "applicationView" ? TABS["applicationView"] : TABS["leadView"],
                selectedLeads: [],
                filterValues: { orderBy: ["-customer__in_office", "-date_added"] },
                columnConfig: getDefaultColumnConfig(this.props.viewType),
            }, () => this.applyTab(this.props.activeTabId))
            return
        }
        // The tab follows the URL: tab clicks, sidebar links and Back/Forward all land here.
        if (prevProps.activeTabId !== this.props.activeTabId) this.applyTab(this.props.activeTabId)
    }

    render() {
        return (
            <Container fluid className="bos-listing-container">
                {this.state.tabs && this.state.tabs.length > 1 && (
                    <ListingTabs tabs={this.state.tabs} activeTab={this.props.activeTabId} onChange={this.props.changeTab} />
                )}
                {this.props.activeTabId !== "reports" && <LeadsListHeader
                    filterValues={this.state.filterValues}
                    setFilterValues={(filterValues) => this.setState({ filterValues })}
                    selectedLeads={this.state.selectedLeads}
                    activeTab={this.props.activeTabId}
                    resetSelectedLeads={() => this.setState({ selectedLeads: [] })}
                    currentUser={this.props.currentUser} location={this.props.location} history={this.props.navigate}
                    refetchQuery={() => this.setState({ refetchLeads: !this.state.refetchLeads })}
                    tableId={this.props.viewType === "leadView" ? "lead" : "application"}
                    columnConfig={this.state.columnConfig}
                    setColumnConfig={this.setColumnConfig}
                    defaultColumnConfig={getDefaultColumnConfig(this.props.viewType)}
                    presets={this.state.presets}
                    setPresets={this.setPresets}
                    defaultPresets={this.state.defaultPresets}
                />}
                <Row>
                    <Col>
                        {this.props.activeTabId === "reports" ? (
                            <ReportsPanel reportId="leads" />
                        ) :
                        this.props.activeTabId &&
                            <LeadsList
                                key={String(this.state.refetchLeads)}
                                orderBy={this.state.filterValues && this.state.filterValues.orderBy ? this.state.filterValues.orderBy : null}
                                updateOrder={this.updateOrder}
                                columnConfig={this.state.columnConfig}
                                currentUser={this.props.currentUser}
                                viewType={this.props.viewType || ""}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                                statuses={this.props.viewType === "applicationView" ? ["Onboarding"] : this.props.activeTabId === "open" ? ["Open", "Contacted"] : this.props.activeTabId === "review" ? ["Need Review"] : this.props.activeTabId === "didnttakecar" ? ["Canceled"] : []}
                                presets={this.state.presets}
                                selectedLeads={this.state.selectedLeads}
                                setSelectedLeads={(selectedLeads) => this.setState({ selectedLeads })}
                                refetchLeads={this.state.refetchLeads}
                                setRefetchQuery={() => this.setState({ refetchLeads: !this.state.refetchLeads })}
                            />
                        }
                    </Col>
                </Row>
            </Container>
        )
    }
}


const LeadsListContainerWithApollo = withApolloClient(LeadsListContainer)

// Leads and Applications are two routes on one component, so the route follows viewType.
export default function LeadsListContainerWithTab(props) {
    const { activeTabId, changeTab } = usePathTab(props.viewType === "applicationView" ? ROUTES.applications : ROUTES.leads)
    return <LeadsListContainerWithApollo {...props} activeTabId={activeTabId} changeTab={changeTab} />
}
